// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require('jquery')
import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import '../js/bootstrap_js_files.js'
import '../js/lazyload.js'
import '../js/video_wrapper.js'
import '../js/miscelaneous.js'
import '../stylesheets/styles.scss'


Rails.start()
Turbolinks.start()
ActiveStorage.start()